import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RollLabelProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/roll-label';

  public getThermalLabelByRollNumber(number: string): Observable<Blob> {
    return this.httpClient.get(this.baseUrl + '/thermal/' + encodeURIComponent(number), {
      responseType: 'blob',
    });
  }

  public getPlanningLabelsByRollNumbers(rollNumbers: string[]): Observable<Blob> {
    return this.httpClient.post(this.baseUrl + '/planning/batch', rollNumbers, {
      responseType: 'blob',
    });
  }

  public getFinalLabelByRollNumber(rollNumber: string, offsetMinutes = -new Date().getTimezoneOffset()): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/${encodeURIComponent(rollNumber)}/final-label?offsetMinutes=${offsetMinutes}`, {
      responseType: 'blob',
    });
  }

  public getFinalLabelsByProductionCardReference(
    productionCardReference: string,
    offsetMinutes = -new Date().getTimezoneOffset(),
  ): Observable<Blob> {
    return this.httpClient.get(
      `${this.baseUrl}/production-card/${productionCardReference}/batch-final-labels?offsetMinutes=${offsetMinutes}`,
      { responseType: 'blob' },
    );
  }
}
